export default __webpack_public_path__ + "static/media/Q17_2_resized.01eaec70.jpg";